import { Component } from '@angular/core';

@Component({
  selector: 'dcc-insights-page',
  templateUrl: 'insights-page.component.html',
  styleUrls: ['insights-page.component.scss'],
})
export class InsightsPageComponent {}
